<script >
const __sfc_main = {};
__sfc_main.props = {
  errorDraft: {
    type: Object,
    required: true
  },
  isSubmittingError: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const errorTypeOptions = [{
    value: 'wrong_dividend',
    label: 'Dividendo erroneo'
  }, {
    value: 'wrong_split',
    label: 'Split erroneo'
  }, {
    value: 'wrong_support',
    label: 'Soporte erroneo'
  }, {
    value: 'wrong_entry',
    label: 'Entrada erronea'
  }, {
    value: 'wrong_historical',
    label: 'Histórico erróneo'
  }, {
    value: 'wrong_broker_ticker',
    label: 'Ticker del broker erroneo'
  }, {
    value: 'others',
    label: 'Otros'
  }];
  const emitErrorDraft = nextDraft => {
    emit('update:error-draft', {
      ...props.errorDraft,
      ...nextDraft
    });
  };
  return {
    emit,
    errorTypeOptions,
    emitErrorDraft
  };
};
export default __sfc_main;
</script>

<template>
    <div class="charting-workspace-inspector__panel-body">
        <div class="charting-workspace-inspector__summary-cell">
            <div class="charting-workspace-inspector__summary-label">Tipo de error</div>
            <select :value="errorDraft.type" class="charting-workspace-inspector__select mt-3" @change="emitErrorDraft({ type: $event.target.value })">
                <option v-for="option in errorTypeOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
            </select>
        </div>

        <div class="charting-workspace-inspector__summary-cell">
            <div class="charting-workspace-inspector__summary-label">Descripción</div>
            <Textarea :model-value="errorDraft.message" rows="8" class="mt-3 w-full" auto-resize placeholder="Describe la incidencia detectada..." @update:model-value="emitErrorDraft({ message: $event })" />
        </div>

        <Button label="Enviar reporte" icon="pi pi-send" :loading="isSubmittingError" @click="emit('submit-error-report')" />
    </div>
</template>
